import { render, staticRenderFns } from "./SocialCampaignTitle.vue?vue&type=template&id=3494ba4e&scoped=true&"
import script from "./SocialCampaignTitle.vue?vue&type=script&lang=js&"
export * from "./SocialCampaignTitle.vue?vue&type=script&lang=js&"
import style0 from "./SocialCampaignTitle.vue?vue&type=style&index=0&id=3494ba4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3494ba4e",
  null
  
)

export default component.exports